import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { Animated, Easing, Image } from 'react-native';
import { SccPressable } from '@/components/SccPressable';
// figma 메타데이터에서 추출한 bubble frame 의 절대 좌표 (hero-local x,y,w,h).
const VARIANT_SPECS = {
    v1_seek_item: {
        x: 156,
        y: 250,
        w: 194,
        h: 52.5,
        source: require('@/assets/img/tutorial/bubble_v1_seek_item.png'),
    },
    v2_seek_map: {
        x: 129,
        y: 240,
        w: 221,
        h: 52.5,
        source: require('@/assets/img/tutorial/bubble_v2_seek_map.png'),
    },
    v3_seek_detail: {
        x: 112,
        y: 240,
        w: 238,
        h: 52,
        source: require('@/assets/img/tutorial/bubble_v3_seek_detail.png'),
    },
    v4_all_items_collected: {
        x: 160,
        y: 242,
        w: 150,
        h: 52.5,
        source: require('@/assets/img/tutorial/bubble_v4_all_items_collected.png'),
    },
    v5_seek_hidden: {
        x: 155,
        y: 235,
        w: 185,
        h: 52.5,
        source: require('@/assets/img/tutorial/bubble_v5_seek_hidden.png'),
    },
    v6_all_complete: {
        x: 141,
        y: 230,
        w: 194,
        h: 52.5,
        source: require('@/assets/img/tutorial/bubble_v6_all_complete.png'),
    },
};
const FLOAT_AMPLITUDE = 10;
const FLOAT_DURATION_MS = 800;
export default function SpeechBubble({ variant, heroWidth, float, onPress, }) {
    const spec = VARIANT_SPECS[variant];
    const scale = heroWidth / 390;
    const floatY = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        if (!float) {
            floatY.stopAnimation();
            floatY.setValue(0);
            return;
        }
        const loop = Animated.loop(Animated.sequence([
            Animated.timing(floatY, {
                toValue: -FLOAT_AMPLITUDE,
                duration: FLOAT_DURATION_MS,
                easing: Easing.inOut(Easing.ease),
                useNativeDriver: true,
            }),
            Animated.timing(floatY, {
                toValue: 0,
                duration: FLOAT_DURATION_MS,
                easing: Easing.inOut(Easing.ease),
                useNativeDriver: true,
            }),
        ]));
        loop.start();
        return () => loop.stop();
    }, [float, floatY]);
    const image = (_jsx(Image, { source: spec.source, style: { width: '100%', height: '100%' }, resizeMode: "contain" }));
    return (_jsx(Animated.View, { pointerEvents: onPress ? 'auto' : 'none', style: {
            position: 'absolute',
            left: spec.x * scale,
            top: spec.y * scale,
            width: spec.w * scale,
            height: spec.h * scale,
            transform: [{ translateY: floatY }],
        }, children: onPress ? (_jsx(SccPressable, { elementName: "tutorial_mission_bubble", logParams: { variant }, onPress: onPress, style: { width: '100%', height: '100%' }, children: image })) : (image) }));
}
